import React, { Component } from 'react';
import Table from '../components/dofa/CompanyObjetives/Index'
import WebpackerReact from 'webpacker-react';

class CompanyObjetiveIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,

            //pagination 

            activePage: 1,
            countPage: 15,
            total: 0
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
            if (format.id === item.id) {
              return { ...item, 
                name: format.name,
              }
            }
            return item;
          })
        });
    }

    loadData = () => {
        fetch(`/dofa/get_company_objetives`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: data.data,
                total: data.total,
                isLoaded: false
            });
        });
    }


    handlePageChange = pageNumber => {
        this.setState({ activePage: pageNumber }); 
        fetch(`/dofa/get_company_objetives?page=${pageNumber}&filter=${this.state.countPage}&filtering=${this.state.filtering}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({ 
                data: data.data,
                total: data.total,
            });
        });     
    };  

    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                    estados={this.props.estados}
                    current_url={this.props.current_url}

                    //pagination
                    totalData={this.state.total}
                    activePage={this.state.activePage}
                    countPage={this.state.countPage}
                    handlePageChange={this.handlePageChange}
                />
            </React.Fragment>
        );
    }
}


export default CompanyObjetiveIndex;
WebpackerReact.setup({ CompanyObjetiveIndex });
